import { create } from "zustand";

interface BlockMoveGhostState {
  /** A long-pressed calendar block is being touch-moved WHILE the inbox drawer
   *  is open (mobile). The in-track ghost sits in a nested stacking context
   *  below the drawer, so we instead float this chip ABOVE everything. */
  active: boolean;
  title: string;
  /** Live finger position (viewport coords). */
  x: number;
  y: number;
  /** Finger is over the inbox → this drop un-schedules (styled as such). */
  overInbox: boolean;
  start: (title: string, x: number, y: number) => void;
  move: (x: number, y: number, overInbox: boolean) => void;
  end: () => void;
}

export const useBlockMoveGhostStore = create<BlockMoveGhostState>((set) => ({
  active: false,
  title: "",
  x: 0,
  y: 0,
  overInbox: false,
  start: (title, x, y) => set({ active: true, title, x, y, overInbox: false }),
  move: (x, y, overInbox) => set({ x, y, overInbox }),
  end: () => set({ active: false, title: "", overInbox: false }),
}));
